module.exports = __webpack_public_path__ + "static/media/ck.420c555e.svg";